import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

const vueRouter = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
        path: '/',
        component: () => import(/* webpackChunkName: "home" */ './views/Home.vue'),
        meta: {
          title: 'Home',
        },
    },
    {
        path: '/conclave',
        component: () => import(/* webpackChunkName: "conclave" */ './views/Conclave.vue'),
        meta: {
          title: 'Conclave',
        },
    },
    {
        path: '/dotkit',
        component: () => import(/* webpackChunkName: "dotkit" */ './views/Dotkit.vue'),
        meta: {
          title: 'Dotkit',
        },
    },
    {
        path: '/glowkit',
        component: () => import(/* webpackChunkName: "glowkit" */ './views/Glowkit.vue'),
        meta: {
          title: 'Glowkit',
        },
    },
    {
        path: '/dotkit-v1',
        component: () => import(/* webpackChunkName: "dotkit" */ './views/Dotkit-v1.vue'),
        meta: {
          title: 'Dotkit v1',
        },
    },
    {
        path: '/moonbase',
        component: () => import(/* webpackChunkName: "moonbase" */ './views/Moonbase.vue'),
        meta: {
          title: 'Moonbase',
        },
    },
    {
        path: '/spectrum',
        component: () => import(/* webpackChunkName: "spectrum" */ './views/Spectrum.vue'),
        meta: {
          title: 'Spectrum',
        },
    },
    {
        path: '/radness',
        component: () => import(/* webpackChunkName: "radness" */ './views/Radness.vue'),
        meta: {
          title: 'Radness',
        },
    },
    {
        path: '/flugridity',
        component: () => import(/* webpackChunkName: "flugridity" */ './views/Flugridity.vue'),
        meta: {
          title: 'Flugridity',
        },
    },
    {
        path: '/flattop',
        component: () => import(/* webpackChunkName: "flattop" */ './views/Flattop.vue'),
        meta: {
          title: 'Flattop',
        },
    },
    {
        path: '/windfish',
        component: () => import(/* webpackChunkName: "windfish" */ './views/Windfish.vue'),
        meta: {
          title: 'Windfish',
        },
    },
    {
      path: '/ii-toolkit',
      component: () => import(/* webpackChunkName: "windfish" */ './views/InsightToolkit.vue'),
      meta: {
        title: 'I+I Toolkit',
      },
    },
    {
        path: '/analytics',
        component: () => import(/* webpackChunkName: "analytics" */ './views/Analytics.vue'),
        meta: {
          title: 'Analytics',
        },
    },
    {
        path: '/adaptive-pill',
        component: () => import(/* webpackChunkName: "analytics" */ './views/AdaptivePill.vue'),
        meta: {
          title: 'Adaptive Pill',
        },
    },
    {
        path: '*',
        component: Home
    },
  ],
  scrollBehavior () {
  // scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

vueRouter.beforeEach((to, from, next) => {
  /* It will change the title when the router is change*/
  if (to.meta.title) {
    document.title = `${to.meta.title} — Blastronaut`;
  } else {
    document.title = 'Blastronaut';
  }
  next();
})

export default vueRouter